const Marquee = ({ phone }) => {
  const phrase = `HARDWOOD FLOORS  /  INSTALLATION  /  REFINISHING  /  REPAIRS  /  STAIRS  /  TRIM + TRANSITIONS  /  ${phone}  /  `;
  return (
    <div className="marquee" data-testid="editorial-marquee-ribbon" aria-label="Sosas Hardwood Floors services">
      <div className="marquee-track"><span>{phrase}</span><span aria-hidden="true">{phrase}</span></div>
    </div>
  );
};

export default Marquee;
